export function departmentErrorMessage(error, fallback) {
    const data = error && error.response && error.response.data;
    return (typeof data === 'string' && data) || (data && (data.msg || data.message)) || fallback;
}

// Общий жизненный цикл диалогов: не закрывать форму до результата и не терять ввод.
export default {
    data() {
        return {saving: false, loading: false, actionError: '', loadFailed: false, loadVersion: 0};
    },
    methods: {
        guardHide(event) {
            if (this.saving) event.preventDefault();
        },
        resetDialog() {
            this.loadVersion++;
            this.loading = false;
            this.actionError = '';
            this.loadFailed = false;
            this.clearForm();
        },
        async loadDepartment() {
            const version = ++this.loadVersion;
            this.loading = true;
            this.loadFailed = false;
            this.actionError = '';
            try {
                const department = await this.$store.dispatch('getDepartment', this.selectedDepartmentId);
                if (version === this.loadVersion) this.setDepartment(department);
            } catch (error) {
                if (version === this.loadVersion) {
                    this.loadFailed = true;
                    this.actionError = departmentErrorMessage(error, 'Не удалось загрузить отдел. Попробуйте ещё раз.');
                }
            } finally {
                if (version === this.loadVersion) this.loading = false;
            }
        },
        async saveDepartment(action, payload, modalId) {
            if (this.saving || this.loading || this.loadFailed) return;
            this.saving = true;
            this.actionError = '';
            try {
                await this.$store.dispatch(action, payload);
                this.saving = false;
                this.$emit('changed');
                this.$bvModal.hide(modalId);
            } catch (error) {
                this.actionError = departmentErrorMessage(error, 'Не удалось выполнить действие. Попробуйте ещё раз.');
            } finally {
                this.saving = false;
            }
        }
    }
};
